export default __webpack_public_path__ + "static/media/forest.e0686856.png";